import { useState } from "react";
import { BRAND } from "../../../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EMPTY = {
    full_name: "",
    phone: "",
    email: "",
    day_window: "",
    time_window: "",
    note: "",
    consent: false,
    website: "",
};

function isEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}

function validate(form) {
    const errors = {};
    if (!form.full_name.trim()) errors.full_name = "Your full name, please.";
    const phone = form.phone.trim();
    if (!phone) errors.phone = "A phone number is required for a callback.";
    else if (phone.replace(/\D/g, "").length < 7)
        errors.phone = "That number looks too short.";
    if (form.email && !isEmail(form.email))
        errors.email = "That email looks off.";
    if (!form.day_window) errors.day_window = "Choose a day window.";
    if (!form.time_window) errors.time_window = "Choose a time window.";
    if (!form.consent)
        errors.consent = "Please agree to be contacted by phone.";
    return errors;
}

export function useCallbackForm() {
    const [form, setForm] = useState(EMPTY);
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState("idle");
    const [submitError, setSubmitError] = useState("");

    const setField = (name, value) => {
        setForm((f) => ({ ...f, [name]: value }));
        if (errors[name]) setErrors((e) => ({ ...e, [name]: undefined }));
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const v = validate(form);
        setErrors(v);
        if (Object.keys(v).length > 0) return;

        setStatus("loading");
        setSubmitError("");
        try {
            const res = await fetch(`${API}/callback`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    ...form,
                    email: form.email || null,
                    note: form.note || null,
                }),
            });
            if (!res.ok) throw new Error("Submission failed");
            setStatus("success");
        } catch {
            setStatus("error");
            setSubmitError(
                `Something went wrong. Please try again or call us directly at ${BRAND.phone}.`,
            );
        }
    };

    const reset = () => {
        setForm(EMPTY);
        setErrors({});
        setStatus("idle");
        setSubmitError("");
    };

    return { form, errors, status, submitError, setField, onSubmit, reset };
}
